<template>
  <div class="container">
    <div class="result">
      <h2>报名成功</h2>
      <p>后续安排请关注“山西博物院”公众号</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VolunteerSignResult'
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: #C2AD8D url(../../../assets/wenwu@2x.png) no-repeat top right / 80%;
  overflow: hidden;
  .result {
    width: 300px;
    height: 405px;
    background: #B0946A;
    border-radius: 8px;
    margin: /*300px*/300px auto 100px;
    text-align: center;
    overflow: hidden;
    h2 {
      color: #f3e6dd;
      font-size: 30px;
      font-weight: bold;
      margin-top: 126px;
    }
    p {
      color: #d9c7bb;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
